export default "__VITE_ASSET__CMc8nLL2__"